import React, { useState, useEffect } from 'react'
import { BiTimer } from 'react-icons/bi'

interface SessionDurationProps {
  weeklyHours: number
  onWeeklyHoursChange: (hours: number) => void
  isDarkMode?: boolean
}

const SessionDuration: React.FC<SessionDurationProps> = ({ weeklyHours, onWeeklyHoursChange }) => {
  const [localValue, setLocalValue] = useState<string>(weeklyHours.toString())

  useEffect(() => {
    setLocalValue(weeklyHours.toString())
  }, [weeklyHours])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setLocalValue(value)

    const numValue = parseFloat(value)
    if (!isNaN(numValue) && numValue >= 0 && numValue <= 168) {
      onWeeklyHoursChange(numValue)
    }
  }

  const handleBlur = () => {
    const numValue = parseFloat(localValue)
    if (isNaN(numValue) || numValue < 1) {
      setLocalValue('1')
      onWeeklyHoursChange(1)
    } else if (numValue > 168) {
      setLocalValue('168')
      onWeeklyHoursChange(168)
    }
  }

  return (
    <div className="session-duration">
      <h3 className="session-duration-title">Carga horária semanal de estudos:</h3>
      <p className="session-duration-description">
        Quantas <strong>horas semanais</strong> você pretende estudar?
      </p>

      <div className="session-duration-container">
        <div className="session-duration-input-wrapper" data-tour="weekly-hours">
          <BiTimer className="session-duration-icon" size={20} />
          <input
            type="number"
            className="session-duration-input"
            max={168}
            min={1}
            step={0.5}
            value={localValue}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="20"
          />
        </div>
      </div>
    </div>
  )
}

export default SessionDuration
